/**
 * Copyright (c) 2019 (original work) Open Assessment Technologies SA ;
 */

/**
 * setNotificationHandler function
 * Sets mouse click event handler on "Submit notification" button
 * @author Igor Suleimanov <ihar@taotesting.com>
 */

function notificationEventHandler() {
    const notificationClass = '.notification';
    const notification = document.querySelector(notificationClass);

    if (notification) {
        notification.remove();
    }

    document.cookie = 'notification-box-closed=true;path=/;';
}

const setNotificationHandler = (buttonSelector) => {
    const notificationButtons = document.querySelectorAll(buttonSelector);
    if (notificationButtons) {
        notificationButtons.forEach(button => {
            button.addEventListener('click', notificationEventHandler);
        });
    }
};

export default setNotificationHandler;
